<template>
	<app-page>
		<div class="main-title">
			财政部、国家税务总局关于《中华人民共和国企业所得税法》公布后企业适用税收法律问题的通知
		</div>
		<div class="flex flex-end clearfix">
			<el-button type="primary" @click="goback()">返回</el-button>
		</div>
		<div class="detail-content">
			<div data-v-bbdef3ee="" class="detail-content">
				<p
					style="text-align:left;"
					size="0"
					_root="undefined"
					__ownerid="undefined"
					__hash="undefined"
					__altered="false"
				>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"
									>各省、自治区、直辖市、计划单列市财政厅(局)、国家税务局、地方税务局，新疆生产建设兵团财务局：</span
								></span
							></span
						></span
					>
				</p>
				<p
					style="text-align:left;"
					size="0"
					_root="undefined"
					__ownerid="undefined"
					__hash="undefined"
					__altered="false"
				></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									《中华人民共和国企业所得税法》(以下称新税法)已经第十届全国人民代表大会第五次会议通过，2007年3月16日以中华人民共和国主席令第六十三号公布，将自2008年1月1日起施行。经国务院批准，现就新税法公布后企业如何适用税收法律问题明确如下：</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									一、新税法第五十七条第一款所称“本法公布前已经批准设立的企业”，是指在2007年3月16日前经工商等登记管理机关登记成立的企业。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									二、2007年3月17日至2007年12月31日期间经工商等登记管理机关登记成立的企业，在2007年12月31日前，分别依照现行《中华人民共和国企业所得税暂行条例》和《中华人民共和国外商投资企业和外国企业所得税法》及其实施细则等相关规定缴纳企业所得税。自2008年1月1日起，上述企业统一适用新税法及国务院相关规定，不享受新税法第五十七条第一款规定的过渡性税收优惠政策。</span
								></span
							></span
						></span
					>
				</p>
				<p></p>
				<p>
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 请遵照执行。</span></span
							></span
						></span
					>
				</p>
				<p></p>
				<p></p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 中华人民共和国财政部</span></span
							></span
						></span
					>
				</p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000"> 国家税务总局</span></span
							></span
						></span
					>
				</p>
				<p style="text-align:right;">
					<span style="font-size:16px"
						><span style="line-height:1.5"
							><span style="letter-spacing:1px"
								><span style="color:#000000">
									二〇〇七年八月三十一日</span
								></span
							></span
						></span
					>
				</p>
			</div>
		</div>
	</app-page>
</template>
<script>
import AppPage from "@/components/semantics/AppPage.vue";

export default {
	components: {
		AppPage
	},
	methods: {
		goback() {
			this.$router.go(-1);
		}
	}
};
</script>